function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTeammatesIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.62
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 5,
    style: {
      fill: "#ee2734"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.79,61.54A11.27,11.27,0,1,1,63.07,50.27,11.28,11.28,0,0,1,51.79,61.54Zm0-16.54a5.27,5.27,0,1,0,5.28,5.27A5.28,5.28,0,0,0,51.79,45Z",
    style: {
      fill: "#fff",
      stroke: "#ee2935",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.57,89.66H60a3,3,0,0,1-3-3V80.48a3,3,0,0,1,6,0v3.18h3.57V75.42a7.67,7.67,0,0,0-6.74-7.61l-6.24,4.66a3,3,0,0,1-3.59,0l-6.24-4.66A7.67,7.67,0,0,0,37,75.42v8.24h4V80.48a3,3,0,0,1,6,0v6.18a3,3,0,0,1-3,3H34a3,3,0,0,1-3-3V75.42A13.68,13.68,0,0,1,44.68,61.75a3,3,0,0,1,1.8.6l5.31,4,5.32-4a3,3,0,0,1,1.79-.6A13.68,13.68,0,0,1,72.57,75.42V86.66A3,3,0,0,1,69.57,89.66Z",
    style: {
      fill: "#fff",
      stroke: "#ee2935",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,42.44l-9.16,6.85-9.15-6.85A13.78,13.78,0,0,0,6.9,56.18V70.66",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.79,17A10.66,10.66,0,1,1,19.14,27.66,10.66,10.66,0,0,1,29.79,17Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.69,
    y1: 55,
    x2: 15.69,
    y2: 70.66,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,70.16V58.65A11,11,0,0,0,82.07,47.72l-7.28,5.45-7.28-5.45",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.79,27.49A8.48,8.48,0,1,1,66.32,36a8.48,8.48,0,0,1,8.47-8.48Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.01,
    y1: 59,
    x2: 86.01,
    y2: 70.16,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTeammatesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/teammates-icon.ebb2618b.svg";
export { ForwardRef as ReactComponent };